import React, { Component } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { IMenuItem } from "../common/Menu/IMenuItem";
import { MenuButton } from "../common/MenuButton";
import { StandardButton } from "../common/StandardButton";
import * as styles from "./ButtonWithMenu.scss";

export interface IButtonWithMenuProps {
    primary: boolean;
    loading: boolean;
    label: string;
    className?: string;
    items: IMenuItem[];
    bottom: boolean;
    disabled?: boolean;
}

@observer
export class ButtonWithMenu extends Component<IButtonWithMenuProps> {
    public render() {
        const { primary, loading, label, className, items, bottom, disabled } =
            this.props;
        return (
            <div className={classnames(styles["button-with-menu"], className)}>
                <StandardButton
                    primary={!loading && primary}
                    loading={loading}
                    className={classnames(
                        styles.button,
                        disabled && styles.disabled,
                    )}
                    disabled={disabled}
                    data-testid="with-menu-button"
                >
                    {label}
                </StandardButton>
                <MenuButton
                    icon="down"
                    items={items}
                    bottom={bottom}
                    className={classnames(
                        styles.menu,
                        disabled && styles.disabled,
                    )}
                    disabled={disabled}
                />
            </div>
        );
    }
}
